import { render, staticRenderFns } from "./thirdindex.vue?vue&type=template&id=160aa246&scoped=true&"
import script from "./thirdindex.vue?vue&type=script&lang=js&"
export * from "./thirdindex.vue?vue&type=script&lang=js&"
import style0 from "./thirdindex.vue?vue&type=style&index=0&id=160aa246&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160aa246",
  null
  
)

export default component.exports